import type { ReactNode } from 'react';
import { Icon } from './Icon';

/** Replaces ion-card / ion-card-header / ion-card-title / ion-card-content. */

export function Card({ children, className = '', id }: { children: ReactNode; className?: string; id?: string }) {
  return (
    <section
      id={id}
      className={`overflow-hidden rounded-xl border border-line bg-raised shadow-sm ${className}`}
    >
      {children}
    </section>
  );
}

export function CardHeader({ children }: { children: ReactNode }) {
  return <div className="border-b border-line px-5 pt-5 pb-3">{children}</div>;
}

/** The Angular .title-icon: 20px, brand orange, before the title. */
export function CardTitle({ children, icon }: { children: ReactNode; icon?: string }) {
  return (
    <h2 className="flex items-center gap-3 text-lg font-semibold text-content">
      {icon && <Icon icon={icon} className="size-5 text-primary" />}
      {children}
    </h2>
  );
}

/** The Angular .card-icon: 16px, beside the subtitle. */
export function CardSubtitle({ children, icon }: { children: ReactNode; icon?: string }) {
  return (
    <p className="flex items-center gap-2 text-sm font-medium text-muted">
      {icon && <Icon icon={icon} className="size-4" />}
      {children}
    </p>
  );
}

export function CardContent({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <div className={`px-5 py-4 ${className}`}>{children}</div>;
}
